import React from "react";
import ReactDOM from "react-dom/client";
import axios from 'axios';
import Login from "./components/Login";
import Checkout from "./checkout/checkout";
import {
    Icon28BoxHeartOutline,
    Icon24Add,
    Icon28ErrorCircleOutline,
    Icon24QuestionOutline,
    Icon24BrowserBack, Icon24Cancel, Icon24Qr
} from '@vkontakte/icons';
import {Icon24ShoppingCartOutline} from '@vkontakte/icons';
import {Icon24FolderOutline} from '@vkontakte/icons';
import {Icon24MenuOutline} from '@vkontakte/icons';
import {
    AdaptivityProvider,
    Avatar,
    ConfigProvider,
    Switch,
    Snackbar,
    AppRoot,
    SplitLayout,
    SplitCol,
    Counter,
    View,
    Panel,
    PanelHeader,
    Div,
    Group,
    Input,

    Epic,
    Tabbar,
    TabbarItem,
    Badge, Spinner,
    ModalRoot,
    ModalPage,
    ModalPageHeader,
    PanelHeaderButton, ButtonGroup, Separator,
    FormItem,
    SimpleCell,
    WebviewType, Button, MiniInfoCell
} from "@vkontakte/vkui";
import '@vkontakte/vkui/dist/components.css';
import '@vkontakte/vkui-tokens/themes/vkCom/cssVars/declarations/onlyVariables.css';

import * as constants from "./assets/constants"

import CartApi from "./api/CartApi";
import Cart from "./checkout/Cart";
import References from "./References";


import Default from "./Default";
import {CookiesProvider} from "react-cookie";

import TakeAPhoto from "./components/TakeAPhoto";
import moment from "moment";
import MonitoringCreate from "./monitoring/MonitoringCreate";

import MainMenu from "./components/MainMenu";
import MonitoringDocs from "./monitoring/MonitoringDocs";
import MonitoringDocForm from "./monitoring/MonitoringDocForm";

import {AddressSuggestions} from 'react-dadata';
import 'react-dadata/dist/react-dadata.css';

import './assets/styles/index.css'
import './map/style.css'
import PDFViewer from "./assets/PDFViewer";
import StorageApi from "./api/StorageApi";
import BaseApi from "./api/BaseApi";
import Clubs from "./Clubs";

import FragmentMap from "./Fragments/Map";
import FragmentSalePointMonitoring from "./Fragments/SalePointMonitoring";
import FragmentKlients from "./Fragments/Klients";
import FragmentMalls from "./Fragments/Malls";
import FragmentSalePoints from "./Fragments/SalePoints";
import FragmentStaff from "./Fragments/Staff";
import FragmentEquipment from "./Fragments/Equipment";
import FragmentStands from "./Fragments/Stands";
import FragmentStandCollections from "./Fragments/StandCollections";
import FragmentStandCollectionBindings from "./Fragments/StandCollectionBindings";
import FragmentSaleDocs from "./Fragments/SaleDocs";
import FragmentReport_ffc from "./Fragments/Report_ffc";
import FragmentIncoming from "./Fragments/Incoming";
import FragmentFacingMonitoring from "./Fragments/FacingMonitoring";
import BaseComponent from "./components/BaseComponent";
import ObjectContextMenu from "./components/ObjectContextMenu";
import {fetchReferenceObjectAndOpen, resolveStoryToObjectType, LEGACY_STORY_ALIASES} from "./utils/objectLinks";
import FragmentOstatki from "./Fragments/Ostatki";
import FragmentOstatki2 from "./Fragments/Ostatki2";
import FragmentFavourites from "./Fragments/Favourites";
import FragmentDataLensExport from "./Fragments/DataLensExport";
import PhotoStorage from "./utils/PhotoStorage";
import PhotoStorageFragment from "./Fragments/PhotoStorageFragment";
import StandsSync from "./utils/localDB/stands";
import StandKitsSync from "./utils/localDB/standkits";
import StandCollectionsSync from "./utils/localDB/standcollections";
import SalePointMonitoringDocsSync from "./utils/localDB/salePointMonitoringDocs";
import { BRANDS_SYNC_TTL_MS } from "./utils/localDB/EntitySync";

import HelpButton from "./assets/HelpButton";
import equipmentTypesApi from "./api/references/equipmentTypes";
import salePointTypesApi from "./api/references/salePointTypes";
import imageAnglesApi from "./api/references/imageAngles";
import trademarksApi from "./api/references/trademarks";
import monitoringQuestionsApi from "./api/references/monitoringQuestions";
import staffPositionsApi from "./api/references/staffPositions";
import {
    equipment_types_cache_key,
    getEquipmentTypes,
    getSalePointsTypes,
    sale_point_types_cache_key,
    image_angles_cache_key,
    getImageAngles,
    trademarks_cache_key,
    getTrademarks,
    getMonitoringQuestions,
    staff_positions_cache_key,
    getStaffPositions,
    equipment_types_last_update_key,
    sale_point_types_last_update_key,
    image_angles_last_update_key,
    trademarks_last_update_key,
    staff_positions_last_update_key,
    monitoring_questions_cache_key,
    monitoring_questions_last_update_key,
    TYPES_CACHE_TTL_MS
} from "./assets/constants";


const removeForm1 = () => {
    let frm = document.getElementById('formLogin')
    if (frm) {
        frm.className += " logined"
    }
}

class App extends BaseComponent {


    onOnline(e) {
        window.postMessage('online')
    }

    onOffline(e) {

        window.postMessage('offline')
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        window.removeEventListener('online', this.onOnline)
        window.removeEventListener('offline', this.onOffline)
    }

    componentDidMount() {
        super.componentDidMount()
        window.addEventListener("click", () => window.postMessage({type: 'openKBInput', guid: ''}), false)
        window.addEventListener('online', this.onOnline)
        window.addEventListener('offline', this.onOffline)
        setTimeout(() => {
            const joinLeft = document.querySelector('.joinLeft')
            const joinRight = document.querySelector('.joinRight')

            if (joinLeft !== null) {
                joinLeft.classList.add('joinLeft-none')
            }
            if (joinRight !== null) {
                joinRight.classList.add('joinRight-none')
            }
        }, 700)


        setTimeout(this.checkAppUserPassFilled, 300)
        setTimeout(this.checkAppUserPassFilled, 1500)
        setTimeout(this.checkAppUserPassFilled, 3000)
        setTimeout(this.checkAppUserPassFilled, 5000)
        setTimeout(this.checkAppUserPassFilled, 6000)
    }

    checkAppUserPassFilled = () => {
        if (this.state.is_logined) return
        const usernameInput = document.getElementById('username')
        const passwordInput = document.getElementById('password')
        const is_applicationInput = document.getElementById('is_application')
        const application_versionInput = document.getElementById('application_version')

        const username = usernameInput.value
        const password = passwordInput.value
        const is_application = is_applicationInput.value
        const application_version = application_versionInput.value


        if (username && password && !this.state.is_logined) {

            window.postMessage({
                type: 'loginDataFromApp',
                data: {username, password, is_application, application_version}
            })
        }
    }

    constructor(props) {

        super(props);
        moment.locale('ru')
        Date.prototype.addDays = function (days) {
            let date = new Date(this.valueOf());
            date.setDate(date.getDate() + days);
            return date;
        }
        axios.defaults.withCredentials = true
        this.openErrorNoty = this.openErrorNoty.bind(this);
        this.onStoryChange = this.onStoryChange.bind(this);
        this.checkLogin = this.checkLogin.bind(this);


        let current_phone = localStorage.getItem(constants.current_phone_key)
        let monarch_bonus_phone = localStorage.getItem(constants.monarch_bonus_phone_key)


        const state = {
            version: "1.12",
            clubs: [],

            mainCatalogSavedState: null,
            FFCCatalogSavedState: null,
            ost2CatalogSavedState: null,

            current_club: null,
            activePanel: 'splash',


            getImageEventName: "setImage",
            numGetImage: 0,

            activePanelMonitoringDocs: "monitoring_panel",
            activePanelMonitoring: "monitoring_create_panel",

            activeStory: 'default_story',
            is_logined: false,


            urlD: 'http://localhost:3000',
            username: '',
            password: '',
            snackbar: null,
            showCartNext: true,

            activePanelCart: constants.AdaptivityContext.isMobile ? 'cart_panel' : 'klient_panel',

            storyHistory: ['default_story'],
            saleDocsState: null,


            current_mointoring_doc: null,

            monitoring_mode: false,
            protect_active: true,
            cartHasBetta: false,
            cartHasLQ: false,
            protect_phone_error: '',
            protect_fio: '',
            protect_fio_error: '',
            protect_address: '',
            protect_address_error: '',
            monarch_bonus_phone: monarch_bonus_phone ? monarch_bonus_phone : '',
            monarch_bonus_phone_error: '',

            ostatki_club_mode: false,
            current_phone: current_phone ? current_phone : '',
            current_phone_def: current_phone ? current_phone : ''
        }
        this.state = {
            ...this.state,
            ...state
        }
        let mass = window.location.href.split(this.state.url + (window.location.href.includes('/react/') ? '/react' : ''))
        let url = mass.length > 1 ? mass[1] : mass[0]
        let url_parts = url.split('/')
        let story = '';
        let panel = '';
        let get_vars = this.getUrlParameters()

        if (url_parts[1] != undefined) {
            story = String(url_parts[1]).split('?')[0]
            if (LEGACY_STORY_ALIASES[story]) {
                story = LEGACY_STORY_ALIASES[story]
            }
        }
        if (url_parts[2] != undefined && url_parts[2][0] != '?') {
            panel = String(url_parts[2]).split('?')[0]
        }
        if (story === 'saledocs' && panel && /^\d/.test(panel)) {
            panel = ''
        }

        // console.log(get_vars)
        this.story = story
        this.panel = panel
        this.get_vars = get_vars
        if (get_vars.search && story == 'ostatki') {
            const last_monitoring_mode = localStorage.getItem('last_monitoring_mode');
            const time = new Date().getTime()

            const last_facing_monitoring_mode = localStorage.getItem('last_facing_monitoring_mode');

            if ((time - last_monitoring_mode * 1) < 15000) {
                this.state.monitoring_mode = true
            } else if ((time - last_facing_monitoring_mode * 1) < 15000) {
                this.story = 'facing_monitoring'
                this.state.activeStory = 'facing_monitoring'
                this.state.activePanelFacingMonitoring = 'facingmonitoring_step2_panel'
            }
            this.state.current_group_id = ''

        }

        this.storyBack = () => {
            if (this.state.storyHistory.length > 1) {
                let story = this.state.storyHistory[this.state.storyHistory.length - 2];
                let old = this.state.storyHistory.slice(0, -1);

                this.setState({activeStory: story, storyHistory: old})
            }
        };

        this.checkLogin()
    }


    setActiveStory(activeStory) {
        activeStory = activeStory || null;
        let storyHistory = this.state.storyHistory ? [...this.state.storyHistory] : ['default_story'];

        if (activeStory === null) {
            storyHistory = [];
        } else {
            storyHistory.push(activeStory);
        }

        this.setState({
            activeStory,
            storyHistory
        });
    };

    openErrorNoty = (text, duration = 2000) => {

        this.setState({errorText: text});

        this.setState({
            snackbar:
                <Snackbar
                    onClick={() => this.setState({snackbar: null})}
                    duration={duration}
                    layout="vertical"
                    onClose={() => this.setState({snackbar: null})}
                    before={<Avatar size={28}><Icon28ErrorCircleOutline fill="var(--vkui--color_icon_negative)"
                                                                        width={14}
                                                                        height={14}/></Avatar>}
                >
                    {text}
                </Snackbar>
        });
    };
    openLoadingNoty = (text, duration = 30000, hideSpinner = false) => {
        // if (this.state.snackbar) return;
        this.setState({loadingText: text});

        this.setState({
            snackbar:
                <Snackbar
                    onClick={() => this.setState({snackbar: null})}
                    duration={duration}
                    onClose={() => this.setState({snackbar: null})}
                    before={<Avatar size={28} style={constants.greenBackground}><Icon24Add fill="#fff" width={14}
                                                                                           height={14}/></Avatar>}
                >
                    {text}{hideSpinner === true ? '' : <Spinner/>}
                </Snackbar>
        });
    };


    openHelpNoty = (text, duration = 4000) => {
        // if (this.state.snackbar) return;
        this.setState({loadingText: text});

        this.setState({
            snackbar:
                <Snackbar
                    duration={duration}
                    onActionClick={() => this.setState({snackbar: null})}
                    onClose={() => this.setState({snackbar: null})}
                    before={<Avatar size={28}><Icon24QuestionOutline width={24}
                                                                     height={24}/></Avatar>}
                >
                    {text}
                </Snackbar>
        });
    };

    isRestrictedStoryForDesigner = (story, user = this.state.current_user) => {
        return constants.isTradeDesigner(user) && constants.isDesignerForbiddenStory(story)
    }

    onStoryChange(e) {
        const requestedStory = e && e.currentTarget && e.currentTarget.dataset
            ? e.currentTarget.dataset.story
            : null

        if (this.isRestrictedStoryForDesigner(requestedStory)) {
            this.openErrorNoty(constants.ACCESS_DENIED_MESSAGE)
            return
        }

        if (requestedStory === 'ostatki2_story' && !constants.checkCanViewOst2(this.state.current_user)) {
            this.openErrorNoty(constants.ACCESS_DENIED_MESSAGE)
            return
        }

        if (e.currentTarget.dataset.story == 'main_menu') {
            console.log(e.currentTarget.dataset.story)
            this.setActiveModal(constants.MODAL_MAIN_MENU)
        } else if (e.currentTarget.dataset.story == 'start_scan') {
            this.startScan()
            //this.setActiveStory('camera_story')
        } else if (e.currentTarget.dataset.story == 'monitoring_story') {
            //window.AndroidFunction.startScan('test')
            this.setState({monitoring_mode: true, mainCatalogSavedState: null})
            this.setState({ostatki_club_mode: false})

            this.setActiveStory('ostatki_story')

        } else if (e.currentTarget.dataset.story == 'facing_monitoring_story') {
            const is_moder = constants.checkIsModer(this.state.current_user)
            const is_admin = constants.checkIsAdmin(this.state.current_user)


            if (this.state.current_user
                && (!this.state.current_user.is_application || this.state.current_user.is_application == '0')
                && !is_moder && !is_admin) {
                this.openErrorNoty('Данный раздел работает только из приложения scladro')
                return
            }

            /*            if (min_auth_version != this.state.current_user.application_version && !is_moder && !is_admin) {
                            if (semver.lte(this.state.current_user.application_version, min_auth_version)) {
                                this.openErrorNoty(`Версия приложения ${this.state.current_user.application_version}, минимально требуется ${min_auth_version}`)
                                return
                            }
                        }*/
            this.setActiveStory('facing_monitoring_story')
        } else if (e.currentTarget.dataset.story == 'ostatki_clubs_story') {
            //window.AndroidFunction.startScan('test')


            this.setState({monitoring_mode: false, mainCatalogSavedState: null})
            this.setState({ostatki_club_mode: true})


            this.setActiveStory('ostatki_clubs_story')
        } else if (e.currentTarget.dataset.story == 'favourites_story') {
            //window.AndroidFunction.startScan('test')
            this.setState({ostatki_club_mode: false, monitoring_mode: false})
            this.setActiveStory('favourites_story')
        } else {
            if (e.toOstatki2) {
                this.setState({ost2CatalogSavedState: null})
            } else {
                this.setState({mainCatalogSavedState: null})
            }
            this.setState({
                saleDocsState: null,
                ostatki_club_mode: false,
                monitoring_mode: false,

            })

            let current_story = e.currentTarget.dataset.story.replace('_story', '')
            try {
                window.history.pushState(null, null, this.state.url + '/' + current_story)
            } catch (e) {

            }

            this.setActiveStory(e.currentTarget.dataset.story)
        }
    }

    checkLogin = () => {
        BaseApi.checkSession().then(async (response) => {

            // eslint-disable-next-line eqeqeq
            if (response.data.success !== undefined && response.data.code !== 'credentials_changed') {
                localStorage.setItem(constants.last_login_data_key, JSON.stringify(response.data))
                await this.loginInit(response.data)
            } else {
                BaseApi.clearAuthStorage()
                this.setState({is_logined: false, current_user: null, activePanel: 'login'})
            }
        }).catch(async (e) => {


            const data = localStorage.getItem(constants.last_login_data_key)
            // axios puts HTTP status on error.response.status (error.status is unreliable)
            const status = e && e.response ? e.response.status : e.status
            const errorCode = e && e.response && e.response.data ? e.response.data.code : undefined

            // 401 / password change: never fake a login from localStorage cache,
            // otherwise the UI looks logged in while every API call keeps failing.
            if (data && data !== "undefined" && status !== 401 && errorCode !== 'credentials_changed') {
                const data_ = JSON.parse(data)
                await this.loginInit(data_)
            } else {
                BaseApi.clearAuthStorage()
                this.setState({is_logined: false, current_user: null, activePanel: 'login'})
            }
        })
    }

    loginInit = async (data_) => {
        const comment = localStorage.getItem(constants.current_order_comment_key)

        this.setState({current_komment: comment})
        this.setState({is_logined: true})
        data_.user.isRetail = data_.user && data_.user.meta && data_.user.meta.market && data_.user.meta.market.code ? true : false


        if (data_.user.is_application && data_.user.is_application !== '0') {
            localStorage.setItem(constants.is_application_key, data_.user.is_application)
        } else {
            const is_application = localStorage.getItem(constants.is_application_key)
            if (is_application) {
                data_.user.is_application = is_application
            }
        }

        this.setState({current_user: data_.user})
        BaseApi.init()
        
        // Инициализируем типы оборудования и торговых точек (один раз при входе)
        // Загружаем типы АП только если у пользователя активна адресная программа
        const hasAddressProgram = data_.user.address_program == '1';
        this.initializeTypes(false, hasAddressProgram).catch(err => {
            console.error('Ошибка инициализации типов:', err);
        });

        StorageApi.setStorageId(data_.user.id)
        let copy_to_clipboard_enabled = localStorage.getItem(constants.copy_to_clipboard_key)

        if (copy_to_clipboard_enabled === null) {
            try {
                await navigator.clipboard.writeText('*');
                localStorage.setItem(constants.copy_to_clipboard_key, '1')
                copy_to_clipboard_enabled = '1'
            } catch (err) {
                localStorage.setItem(constants.copy_to_clipboard_key, '0')
                copy_to_clipboard_enabled = '0'
            }
        }
        constants.AdaptivityContext.copy_to_clipboard_enabled = copy_to_clipboard_enabled === '1'

        if (data_.user.default_klient) {
            const default_klient = data_.user.default_klient
            default_klient.name = default_klient.title
            default_klient.id = default_klient.external_id

            this.setState({default_klient})
            if (default_klient != undefined && default_klient.meta != undefined && default_klient.meta.Адреса != undefined && default_klient.meta.Адреса[0] != undefined) {

                this.setState({default_address: default_klient.meta.Адреса[0]})
            }
        }

        this.setState({activePanel: 'logined'})
        removeForm1()
        const clubs = []
        if (data_.user['meta'] && data_.user['meta']['settings']) {
            if (data_.user['meta']['settings']['firm_fit_club']) {
                clubs.push({
                    code: 'is_firm_fit',
                    name: 'Firm Fit Club'
                })
            }
            if (data_.user['meta']['settings']['primavera_club']) {
                clubs.push({
                    code: 'is_primavera',
                    name: 'Primavera Club'
                })
            }
            if (data_.user['meta']['settings']['betta_club']) {
                clubs.push({
                    code: 'is_betta_',
                    name: 'BETTA'
                })
            }
            if (data_.user['meta']['settings']['lq_club']) {
                clubs.push({
                    code: 'is_lq',
                    name: 'L\'Quarzo'
                })
            }
        }
        this.setState({clubs})
        if (clubs.length > 0) {
            this.setState({current_club: clubs[0]})
        }
        if (this.story) {
            const requestedStory = this.story + '_story'
            if (this.isRestrictedStoryForDesigner(requestedStory, data_.user)) {
                this.openErrorNoty(constants.ACCESS_DENIED_MESSAGE)
                this.setActiveStory(data_.user.address_program == '1' ? 'references_story' : 'default_story')
            } else {
                this.setActiveStory(requestedStory)
                this.setState({
                    activeStoryPanel: this.panel.length ? this.panel + '_panel' : this.story + '_panel',
                    get_vars: this.get_vars
                })
            }
        }
        CartApi.getItems()
        BaseApi.getRecSclads()
        const techBannerOn = String(data_.user.tech_banner_enabled) === '1'
        const exchangeBanner = String(data_.user.banner || '').trim()
        if (techBannerOn && exchangeBanner && exchangeBanner !== '#####') {
            window.postMessage({type: 'error', text: exchangeBanner, timeout: 300000})
        }
        window.postMessage({type: 'isLogined', value: true, user: data_.user})
        //this.getCart()
        setTimeout(() => {
            this.tryOpenReferenceDeepLink();
        }, 200);
    }

    /**
     * Открытие карточки справочника по URL вида .../salepoints?id=123 после входа.
     */
    tryOpenReferenceDeepLink = () => {
        if (!this.state.is_logined) {
            return;
        }
        if (this.isRestrictedStoryForDesigner(`${this.story}_story`)) {
            return;
        }
        const rawId = this.get_vars && this.get_vars.id;
        if (!rawId || !this.story) {
            return;
        }
        const id = parseInt(String(rawId).trim(), 10);
        if (Number.isNaN(id) || id <= 0) {
            return;
        }
        const objectType = resolveStoryToObjectType(this.story);
        if (!objectType) {
            return;
        }
        fetchReferenceObjectAndOpen(objectType, id);
    };

    onChange = (state) => {


        this.setState(state);

    };

    changeCurrentClub = (club) => {
        this.setState({current_club: club})
    }

    refreshState = () => {
        setTimeout(() => {
            this.setState({})
        }, 500)
    }

    MainMenu = () => {
        return <MainMenu
            setActiveModal={(e) => this.setActiveModal(e)}
            onStoryChange={(e) => this.onStoryChange(e)}
            setActiveStory={(e) => this.setActiveStory(e)}
            current_user={this.state.current_user}
            setState={(state) => this.setState(state)}
            doLogout={this.doLogout}
        />
    }

    render() {
        //const { viewWidth } = useAdaptivity();
        // const { activeView, activePanel } = useRouterSelector();

        const getWidth = () => window.innerWidth;
        const isMobile = (w) => w < 600;
        const AdaptivityContext = {
            w: getWidth(),
            isMobile: isMobile(getWidth()),
        };
        const self = this
        const main_modals = (
            <ModalRoot activeModal={this.state.activeModal}>


                <ModalPage hideCloseButton={true}
                           id={constants.MODAL_MAIN_MENU}
                           onClose={this.modalBack}
                           settlingHeight={100}
                           style={{
                               width: "80%",
                               justifyContent: "flex-start"
                           }}
                           header={
                               <ModalPageHeader
                                   after={<PanelHeaderButton
                                       onClick={this.modalBack}><Icon24Cancel/></PanelHeaderButton>}

                               >
                                   <p className="logo-text-burger">МОНА<span className="letter-color-burger">Р</span>Х
                                   </p>
                               </ModalPageHeader>
                           }
                >
                    {this.MainMenu()}
                </ModalPage>

            </ModalRoot>
        );

        return (
            <AppRoot>
                <ObjectContextMenu/>
                <SplitLayout modal={main_modals} header={<PanelHeader separator={false}/>}>
                    <SplitCol spaced={false}>
                        <View activePanel={this.state.activePanel}>
                            <Panel id="login">

                                <Login base_url={this.state.base_url} onChange={this.onChange}
                                       username={this.state.username}
                                       password={this.state.password}/>

                                {this.state.snackbar}
                            </Panel>
                            <Panel id="splash">
                                <div className="join-block">
                                    <img src="/react/img/joinLeft.png" className="joinLeft"/>
                                    <img src="/react/img/joinRight.png" className="joinRight"/>
                                    <div className="join-block-flex">
                                        <h2 className="join-block-head">МОНА<span
                                            className="join-block-red">Р</span>Х</h2>
                                        <p className="join-block-text">Опт – наша профессия</p>
                                    </div>
                                </div>
                                {this.state.snackbar}
                            </Panel>
                            <Panel id="logined">
                                <Epic activeStory={this.state.activeStory} tabbar={
                                    <Tabbar>
                                        <TabbarItem
                                            onClick={this.onStoryChange}
                                            data-story="main_menu"
                                            text={"Меню"}
                                        ><Icon24MenuOutline/></TabbarItem>
                                        {constants.checkCanViewCatalog(this.state.current_user) &&
                                            <TabbarItem
                                                indicator={this.state.current_user && this.state.current_user.has_favourites == '1' ?
                                                    <Badge mode="prominent"/> : ''}
                                                onClick={(e) => {
                                                    this.setState({
                                                        current_group_id: '',
                                                        monitoring_mode: false,
                                                        ostatki_club_mode: false
                                                    });
                                                    window.postMessage({
                                                        type: "applyCurrentFilter",
                                                        value: {filters: [], items: []}
                                                    })
                                                    this.setActiveModal(null);
                                                    this.setActiveStory('ostatki_story')


                                                    this.onStoryChange(e)
                                                }
                                                }
                                                selected={this.state.activeStory === 'favourites_story'}
                                                data-story="favourites_story"
                                                text="Избранное"
                                            ><Icon28BoxHeartOutline/></TabbarItem>}
                                        {constants.checkCanViewCatalog(this.state.current_user) &&
                                            <TabbarItem
                                                onClick={(e) => {
                                                    this.setState({
                                                        current_group_id: '',
                                                        monitoring_mode: false,
                                                        ostatki_club_mode: false
                                                    });
                                                    window.postMessage({
                                                        type: "applyCurrentFilter",
                                                        value: {filters: [], items: []}
                                                    })
                                                    this.setState({mainCatalogSavedState: null})
                                                    this.setActiveModal(null);
                                                    this.setActiveStory('ostatki_story')


                                                    this.onStoryChange(e)
                                                }
                                                }
                                                selected={this.state.activeStory === 'ostatki_story'}
                                                data-story="ostatki_story"
                                                text="Каталог"
                                            ><Icon24FolderOutline/></TabbarItem>}

                                        <TabbarItem
                                            onClick={this.onStoryChange}
                                            selected={this.state.activeStory === 'cart_story'}
                                            data-story="cart_story"
                                            indicator={CartApi.items.length ?
                                                <Counter size="s" mode="prominent">
                                                    {CartApi.items.length}
                                                </Counter> : ''}
                                            text="Корзина"
                                        ><Icon24ShoppingCartOutline/></TabbarItem>
                                        <TabbarItem

                                            onClick={this.onStoryChange}
                                            data-story="start_scan"
                                            text="Сканнер"
                                        ><Icon24Qr/></TabbarItem>

                                    </Tabbar>
                                }>

                                    <View activePanel="main_panel" id="default_story">
                                        <Panel id="main_panel">
                                            <SplitLayout>
                                                {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                                                <SplitCol>
                                                    <Default current_user={this.state.current_user}
                                                             base_url={this.state.base_url}
                                                             main_url={this.state.url}
                                                             clubs={this.state.clubs}
                                                             changeStory={this.onStoryChange}/>
                                                </SplitCol>
                                            </SplitLayout>
                                        </Panel>
                                    </View>
                                    <View activePanel="help_panel" id="help_story">
                                        <Panel id="help_panel">
                                            <SplitLayout>
                                                {AdaptivityContext.isMobile ? '' : this.MainMenu()}
                                                <SplitCol>
                                                    {this.state.current_user &&
                                                        <PDFViewer
                                                            file={this.state.url + (!(this.state.current_user['meta']['market'] && this.state.current_user['meta']['market']['code']) ? '/Manual_NotMarket.pdf' : '/Manual_Market.pdf')}/>}


                                                </SplitCol>
                                            </SplitLayout>
                                        </Panel>
                                    </View>
                                    <View activePanel="main_panel_clubs" id="clubs_story">
                                        <Panel id="main_panel_clubs">
                                            <SplitLayout>
                                                {AdaptivityContext.isMobile ? '' : this.MainMenu()}

                                                <SplitCol>
                                                    <Clubs current_user={this.state.current_user}
                                                           current_club={this.state.current_club}
                                                           clubs={this.state.clubs}
                                                           changeStory={this.onStoryChange}
                                                           changeClub={this.changeCurrentClub}
                                                           base_url={this.state.base_url}/>
                                                </SplitCol>
                                            </SplitLayout>
                                        </Panel>
                                    </View>

                                    <View activePanel="main_panel_references" id="references_story">
                                        <Panel id="main_panel_references">
                                            <SplitLayout>
                                                {AdaptivityContext.isMobile ? '' : this.MainMenu()}

                                                <SplitCol>
                                                    <References current_user={this.state.current_user}
                                                                current_club={this.state.current_club}
                                                                clubs={this.state.clubs}
                                                                changeStory={this.onStoryChange}
                                                                changeClub={this.changeCurrentClub}
                                                                base_url={this.state.base_url}/>
                                                </SplitCol>
                                            </SplitLayout>
                                        </Panel>
                                    </View>

                                    <PhotoStorageFragment id="photo_storage_story"/>
                                    <FragmentStands
                                        id="stands_story"
                                        base_url={this.state.base_url}
                                        setActiveModal={(e) => this.setActiveModal(e)}
                                        onStoryChange={(e) => this.onStoryChange(e)}
                                        setActiveStory={(e) => this.setActiveStory(e)}
                                        current_user={this.state.current_user}
                                        setState={(state) => this.setState(state)}
                                        doLogout={this.doLogout}
                                    />
                                    <FragmentStandCollections
                                        id="standcollections_story"
                                        base_url={this.state.base_url}
                                        setActiveModal={(e) => this.setActiveModal(e)}
                                        onStoryChange={(e) => this.onStoryChange(e)}
                                        setActiveStory={(e) => this.setActiveStory(e)}
                                        current_user={this.state.current_user}
                                        setState={(state) => this.setState(state)}
                                        doLogout={this.doLogout}
                                    />
                                    <FragmentStandCollectionBindings
                                        id="stand_collection_bindings_story"
                                        base_url={this.state.base_url}
                                        setActiveModal={(e) => this.setActiveModal(e)}
                                        onStoryChange={(e) => this.onStoryChange(e)}
                                        setActiveStory={(e) => this.setActiveStory(e)}
                                        current_user={this.state.current_user}
                                        setState={(state) => this.setState(state)}
                                        doLogout={this.doLogout}
                                    />
                                    <FragmentEquipment

                                        id="equipment_story"
                                        base_url={this.state.base_url}
                                        setActiveModal={(e) => this.setActiveModal(e)}
                                        onStoryChange={(e) => this.onStoryChange(e)}
                                        setActiveStory={(e) => this.setActiveStory(e)}
                                        current_user={this.state.current_user}
                                        setState={(state) => this.setState(state)}
                                        doLogout={this.doLogout}
                                    />
                                    <FragmentKlients
                                        id="klients_story"
                                        base_url={this.state.base_url}
                                        setActiveModal={(e) => this.setActiveModal(e)}
                                        onStoryChange={(e) => this.onStoryChange(e)}
                                        setActiveStory={(e) => this.setActiveStory(e)}
                                        current_user={this.state.current_user}
                                        setState={(state) => this.setState(state)}
                                        doLogout={this.doLogout}
                                    />
                                    <FragmentMap
                                        current_user={this.state.current_user}
                                        id="sale_point_map_story"
                                        base_url={this.state.base_url}
                                        setActiveModal={(e) => this.setActiveModal(e)}
                                        onStoryChange={(e) => this.onStoryChange(e)}
                                        setActiveStory={(e) => this.setActiveStory(e)}
                                        
                                        setState={(state) => this.setState(state)}
                                        doLogout={this.doLogout}
                                    />
                                    <FragmentDataLensExport
                                        current_user={this.state.current_user}
                                        id="datalens_export_story"
                                        base_url={this.state.base_url}
                                        setActiveModal={(e) => this.setActiveModal(e)}
                                        onStoryChange={(e) => this.onStoryChange(e)}
                                        setActiveStory={(e) => this.setActiveStory(e)}
                                        setState={(state) => this.setState(state)}
                                        doLogout={this.doLogout}
                                    />
                                    <FragmentSalePointMonitoring
                                        id="sale_point_monitoring_story"
                                        base_url={this.state.base_url}
                                        setActiveModal={(e) => this.setActiveModal(e)}
                                        onStoryChange={(e) => this.onStoryChange(e)}
                                        setActiveStory={(e) => this.setActiveStory(e)}
                                        current_user={this.state.current_user}
                                        setState={(state) => this.setState(state)}
                                        doLogout={this.doLogout}
                                    />
                                    <FragmentMalls
                                        id="malls_story"
                                        base_url={this.state.base_url}
                                        setActiveModal={(e) => this.setActiveModal(e)}
                                        onStoryChange={(e) => this.onStoryChange(e)}
                                        setActiveStory={(e) => this.setActiveStory(e)}
                                        current_user={this.state.current_user}
                                        setState={(state) => this.setState(state)}
                                        doLogout={this.doLogout}
                                    />
                                    <FragmentSalePoints
                                        id="salepoints_story"
                                        base_url={this.state.base_url}
                                        setActiveModal={(e) => this.setActiveModal(e)}
                                        onStoryChange={(e) => this.onStoryChange(e)}
                                        setActiveStory={(e) => this.setActiveStory(e)}
                                        current_user={this.state.current_user}
                                        setState={(state) => this.setState(state)}
                                        doLogout={this.doLogout}
                                    />
                                    <FragmentStaff
                                        id="staff_story"
                                        base_url={this.state.base_url}
                                        setActiveModal={(e) => this.setActiveModal(e)}
                                        onStoryChange={(e) => this.onStoryChange(e)}
                                        setActiveStory={(e) => this.setActiveStory(e)}
                                        current_user={this.state.current_user}
                                        setState={(state) => this.setState(state)}
                                        doLogout={this.doLogout}
                                    />


                                    <FragmentSaleDocs
                                        id="saledocs_story"
                                        base_url={this.state.base_url}
                                        setActiveModal={(e) => this.setActiveModal(e)}
                                        onStoryChange={(e) => this.onStoryChange(e)}
                                        setActiveStory={(e) => this.setActiveStory(e)}
                                        current_user={this.state.current_user}
                                        setState={(state) => this.setState(state)}
                                        doLogout={this.doLogout}
                                    />
                                    <FragmentReport_ffc
                                        id="report_ffc_story"
                                        base_url={this.state.base_url}
                                        setActiveModal={(e) => this.setActiveModal(e)}
                                        onStoryChange={(e) => this.onStoryChange(e)}
                                        setActiveStory={(e) => this.setActiveStory(e)}
                                        current_user={this.state.current_user}
                                        current_club={this.state.current_club}
                                        setState={(state) => this.setState(state)}
                                        doLogout={this.doLogout}
                                    />
                                    <FragmentIncoming
                                        id="incoming_story"
                                        base_url={this.state.base_url}
                                        setActiveModal={(e) => this.setActiveModal(e)}
                                        onStoryChange={(e) => this.onStoryChange(e)}
                                        setActiveStory={(e) => this.setActiveStory(e)}
                                        current_user={this.state.current_user}

                                        setState={(state) => this.setState(state)}
                                        doLogout={this.doLogout}
                                    />
                                    <FragmentFacingMonitoring
                                        id="facing_monitoring_story"
                                        base_url={this.state.base_url}
                                        setActiveModal={(e) => this.setActiveModal(e)}
                                        onStoryChange={(e) => this.onStoryChange(e)}
                                        setActiveStory={(e) => this.setActiveStory(e)}
                                        current_user={this.state.current_user}

                                        setState={(state) => this.setState(state)}
                                        doLogout={this.doLogout}
                                    />
                                    <FragmentOstatki
                                        id="ostatki_story"
                                        base_url={this.state.base_url}
                                        setActiveModal={(e) => this.setActiveModal(e)}
                                        onStoryChange={(e) => this.onStoryChange(e)}
                                        setActiveStory={(e) => this.setActiveStory(e)}
                                        current_user={this.state.current_user}
                                        current_club={this.state.current_club}

                                        activeStory={this.state.activeStory}
                                        monitoring_mode={this.state.monitoring_mode}
                                        ostatki_club_mode={this.state.ostatki_club_mode}
                                        mainCatalogSavedState={this.state.mainCatalogSavedState}
                                        ost2CatalogSavedState={this.state.ost2CatalogSavedState}


                                        get_vars={this.state.get_vars}
                                        current_filter={this.state.current_filter}
                                        current_filter_items={this.state.current_filter_items}

                                        setState={(state) => this.setState(state)}
                                        doLogout={this.doLogout}
                                    />
                                    <FragmentOstatki
                                        id="ostatki_clubs_story"
                                        base_url={this.state.base_url}
                                        setActiveModal={(e) => this.setActiveModal(e)}
                                        onStoryChange={(e) => this.onStoryChange(e)}
                                        setActiveStory={(e) => this.setActiveStory(e)}
                                        current_user={this.state.current_user}
                                        current_club={this.state.current_club}

                                        activeStory={this.state.activeStory}
                                        monitoring_mode={this.state.monitoring_mode}
                                        ostatki_club_mode={true}
                                        mainCatalogSavedState={this.state.mainCatalogSavedState}
                                        ost2CatalogSavedState={this.state.ost2CatalogSavedState}


                                        get_vars={this.state.get_vars}
                                        current_filter={this.state.current_filter}
                                        current_filter_items={this.state.current_filter_items}

                                        setState={(state) => this.setState(state)}
                                        doLogout={this.doLogout}
                                    />
                                    <FragmentOstatki2
                                        id="ostatki2_story"
                                        base_url={this.state.base_url}
                                        setActiveModal={(e) => this.setActiveModal(e)}
                                        onStoryChange={(e) => this.onStoryChange(e)}
                                        setActiveStory={(e) => this.setActiveStory(e)}
                                        current_user={this.state.current_user}
                                        current_club={this.state.current_club}

                                        activeStory={this.state.activeStory}
                                        monitoring_mode={this.state.monitoring_mode}
                                        ostatki_club_mode={this.state.ostatki_club_mode}
                                        mainCatalogSavedState={this.state.mainCatalogSavedState}
                                        ost2CatalogSavedState={this.state.ost2CatalogSavedState}


                                        get_vars={this.state.get_vars}
                                        current_filter={this.state.current_filter}
                                        current_filter_items={this.state.current_filter_items}

                                        setState={(state) => this.setState(state)}
                                        doLogout={this.doLogout}
                                    />
                                    <FragmentFavourites
                                        id="favourites_story"
                                        base_url={this.state.base_url}
                                        setActiveModal={(e) => this.setActiveModal(e)}
                                        onStoryChange={(e) => this.onStoryChange(e)}
                                        setActiveStory={(e) => this.setActiveStory(e)}
                                        current_user={this.state.current_user}
                                        current_club={this.state.current_club}

                                        activeStory={this.state.activeStory}
                                        monitoring_mode={this.state.monitoring_mode}
                                        ostatki_club_mode={this.state.ostatki_club_mode}
                                        mainCatalogSavedState={this.state.mainCatalogSavedState}
                                        ost2CatalogSavedState={this.state.ost2CatalogSavedState}


                                        get_vars={this.state.get_vars}
                                        current_filter={this.state.current_filter}
                                        current_filter_items={this.state.current_filter_items}

                                        setState={(state) => this.setState(state)}
                                        doLogout={this.doLogout}
                                    />
                                    <View activePanel={this.state.activePanelMonitoringDocs} id="monitoringdocs_story">

                                        <Panel id="monitoring_panel">
                                            <SplitLayout>
                                                {AdaptivityContext.isMobile ? '' : this.MainMenu()}

                                                <SplitCol>
                                                    <MonitoringDocs base_url={this.state.base_url}
                                                                    select_doc={this.selectCurrentMonitoringDoc}/>
                                                </SplitCol>
                                                {AdaptivityContext.isMobile ? '' :
                                                    <SplitCol>
                                                        <MonitoringDocForm
                                                            base_url={this.state.base_url}
                                                            current_doc={this.state.current_mointoring_doc}
                                                            show_back={true}
                                                            hideDoc={() => this.setState({activePanelMonitoringDocs: "monitoring_panel"})}
                                                            select_doc={this.selectCurrentMonitoringDoc}
                                                        />
                                                    </SplitCol>}
                                            </SplitLayout>
                                        </Panel>
                                        <Panel id="monitoring_form_panel">
                                            <MonitoringDocForm
                                                base_url={this.state.base_url}
                                                current_doc={this.state.current_mointoring_doc}
                                                show_back={true}
                                                hideDoc={() => this.setState({activePanelMonitoringDocs: "monitoring_panel"})}
                                                select_doc={this.selectCurrentMonitoringDoc}
                                            />
                                        </Panel>
                                    </View>
                                    <View activePanel={this.state.activePanelMonitoring} id="monitoring_create_story">
                                        <Panel id="monitoring_create_panel">
                                            <MonitoringCreate
                                                base_url={this.state.base_url}
                                                show_back={true}
                                                changeCurrentProduct={this.changeCurrentProduct}
                                                current_product={this.state.current_product}
                                                openLoadingNoty={this.openLoadingNoty}
                                            />
                                        </Panel>
                                        <Panel id="photo_panel">
                                            <SplitLayout>
                                                <SplitCol width={"50%"}>
                                                    <TakeAPhoto
                                                        hidePhotos={() => this.setState({activePanelMonitoring: 'monitoring_create_panel'})}
                                                        url={this.state.url} openErrorNoty={this.openErrorNoty}/>
                                                </SplitCol>
                                            </SplitLayout>

                                        </Panel>
                                    </View>


                                    <View activePanel="camera_panel" id="camera_story">
                                        <Panel id="camera_panel">
                                            <TakeAPhoto hidePhotos={this.hideSclads} url={this.state.url}
                                                        openErrorNoty={this.openErrorNoty}/>
                                        </Panel>
                                    </View>
                                    <View activePanel={this.state.activePanelCart} id="cart_story">
                                        <Panel id="cart_panel">
                                            <Div>
                                                <h1>Корзина</h1>
                                                <Cart user={this.state.current_user} base_url={this.state.base_url}
                                                      refresh={() => this.setState({})}/>

                                                <Separator/>

                                                <ButtonGroup style={{
                                                    justifyContent: 'flex-end',
                                                    display: (CartApi.items.length > 0 && this.state.showCartNext ? 'flex' : 'none')
                                                }} stretched>
                                                    {constants.checkCanMakeDocs(this.state.current_user) ?
                                                        <Button
                                                            style={{minWidth: constants.AdaptivityContext.isMobile ? '50%' : '20%'}}
                                                            size="l"
                                                            onClick={() => this.setState({activePanelCart: 'klient_panel'})}>Далее</Button>
                                                        :
                                                        <MiniInfoCell before={<Icon28ErrorCircleOutline/>}>
                                                            Нет прав на создание заказов. Обратитесь к администратору
                                                        </MiniInfoCell>
                                                    }
                                                </ButtonGroup>
                                            </Div>
                                        </Panel>
                                        <Panel id="klient_panel">

                                            <Checkout
                                                current_user={this.state.current_user}
                                                base_url={this.state.base_url}
                                                father={this}
                                                default_klient={this.state.default_klient}
                                                default_address={this.state.default_address}
                                            />

                                        </Panel>
                                        <Panel id="cart_ffc_panel">
                                            <Checkout
                                                current_user={this.state.current_user}
                                                base_url={this.state.base_url}
                                                father={this}
                                                default_klient={this.state.default_klient}
                                                default_address={this.state.default_address}
                                            >
                                                <SplitLayout>
                                                    {AdaptivityContext.isMobile ? '' : this.MainMenu()}

                                                    <SplitCol width="20%">
                                                        <Div>
                                                            <FormItem top={<div>Ваш телефон для
                                                                monarch-bonus?{(this.state.cartHasBetta || this.state.cartHasLQ) &&
                                                                    <HelpButton
                                                                        text="Укажите телефон который вы используете в monarh-bonus и свое имя и фамилию"/>}</div>}
                                                                      status={this.state.monarch_bonus_phone_error ? 'error' : ''}
                                                                      bottom={this.state.monarch_bonus_phone_error}>
                                                                <Input tabIndex="0"
                                                                       id="monarch_bonus_phone"
                                                                       type="text"
                                                                       placeholder="999 99-99"

                                                                       status={this.state.monarch_bonus_phone_error ? 'error' : 'default'}
                                                                />
                                                            </FormItem>
                                                            {!(this.state.cartHasBetta || this.state.cartHasLQ) &&
                                                                <SimpleCell Component="label"
                                                                            after={<Switch
                                                                                checked={this.state.protect_active}
                                                                                onChange={(e) => {
                                                                                    this.setState({protect_active: e.target.checked})
                                                                                }}/>}>
                                                                    Установить защиту
                                                                </SimpleCell>}
                                                            <Group
                                                                style={{display: this.state.protect_active ? 'inherit' : 'none'}}>
                                                                {!(this.state.cartHasBetta || this.state.cartHasLQ) &&
                                                                    <FormItem top="1. Заполните телефон"
                                                                              status={this.state.protect_phone_error ? 'error' : ''}
                                                                              bottom={this.state.protect_phone_error}>
                                                                        <Input tabIndex="0"
                                                                               id="protect_phone"
                                                                               type="text"
                                                                               placeholder="999 99-99"

                                                                               status={this.state.protect_phone_error ? 'error' : 'default'}
                                                                        />
                                                                    </FormItem>}
                                                                <FormItem top="2. Заполните ФИО"
                                                                          status={this.state.protect_fio_error ? 'error' : ''}
                                                                          bottom={this.state.protect_fio_error}>
                                                                    <Input tabIndex="0"
                                                                           id="protect_fio"
                                                                           type="text"
                                                                           value={this.state.protect_fio}
                                                                           onChange={(e) => this.setState({protect_fio: e.target.value})}
                                                                           status={this.state.protect_fio_error ? 'error' : 'default'}
                                                                    />
                                                                </FormItem>
                                                                {!(this.state.cartHasBetta || this.state.cartHasLQ) &&
                                                                    <FormItem top="2. Заполните Адрес объекта"
                                                                              status={this.state.protect_address_error ? 'error' : ''}
                                                                              bottom={this.state.protect_address_error}>
                                                                        <AddressSuggestions tabIndex="0"
                                                                                            token="5367f393d0040cdc339492986bea8f13ebeec2a5"
                                                                                            defaultQuery={this.state.protect_address}
                                                                                            onChange={this.setProtectAddress}

                                                                        />
                                                                    </FormItem>}
                                                            </Group>
                                                            <Separator/>

                                                            <ButtonGroup style={{
                                                                justifyContent: 'flex-end',
                                                                display: (CartApi.items.length > 0 && this.state.showCartNext ? 'flex' : 'none')
                                                            }} stretched>
                                                                <Button stretched={constants.AdaptivityContext.isMobile}
                                                                        disabled={this.state.send_order_pending}
                                                                        style={{minWidth: constants.AdaptivityContext.isMobile ? 'inherit' : '20%'}}
                                                                        size="l"
                                                                        onClick={() => this.setState({activePanelCart: 'klient_panel'})}>Назад</Button>
                                                                <Button stretched={constants.AdaptivityContext.isMobile}
                                                                        loading={this.state.send_order_pending}
                                                                        style={{minWidth: constants.AdaptivityContext.isMobile ? 'inherit' : '20%'}}
                                                                        size="l"
                                                                        onClick={() => window.postMessage("validateStep3")}>Далее</Button>
                                                            </ButtonGroup>
                                                        </Div>
                                                    </SplitCol>
                                                    {AdaptivityContext.isMobile ? '' :
                                                        <SplitCol width="20%">
                                                            <h1>Корзина</h1>
                                                            <Cart user={this.state.current_user}
                                                                  base_url={this.state.base_url}
                                                                  refresh={() => this.setState({})}/>

                                                        </SplitCol>}
                                                </SplitLayout>
                                            </Checkout>
                                        </Panel>
                                    </View>

                                </Epic>
                                {this.state.snackbar}
                            </Panel>
                        </View>
                    </SplitCol>
                </SplitLayout>
            </AppRoot>
        );
    }

    selectCurrentMonitoringDoc = (item) => {
        this.setState({current_mointoring_doc: item})
        if (constants.AdaptivityContext.isMobile) {
            this.setState({activePanelMonitoringDocs: "monitoring_form_panel"})
        }
    }

    hideDoc = (is_club = false) => {
        if (is_club) {
            this.setState({activePanelReportFFC: "report_ffc_saledocs_panel"})
        } else {
            this.setState({activePanelSaleDocs: "saledocs_panel"})
        }
    }


    doLogout = () => {

        const body = new FormData()
        window.postMessage("doLogout")
        axios.post(this.state.base_url + '?app=login&act=logout', body,
            {
                withCredentials: true,
                headers: {
                    'Content-Type': 'multipart/form-data',

                }

            }
        ).then((response) => {
            console.log(response)
            if (response.data.success === true) {
                /*                if (window.AndroidFunction) {
                                    window.AndroidFunction.logout('1')
                                }*/
                localStorage.setItem(constants.rec_sclad_key, "")
                BaseApi.clearRecScladsCache()
                BaseApi.clearAuthStorage()

                this.setActiveModal(null)

                this.setState({default_klient: null, default_address: null, activeStory: 'default_story'})
                this.setState({is_logined: false, activePanel: 'login'})

                setTimeout(() => {
                    this.setState({orderData: null})
                    window.postMessage("doLogout")
                }, 700)

            } else {


                this.openErrorNoty("Ошибка выхода из аккаунта, возможно нет интернета")
            }
        })

    }


    startScan = () => {
        if (!this.state.current_user.is_application || this.state.current_user.is_application == '0') {
            return
        }
        if (this.state.monitoring_mode) {
            localStorage.setItem('last_monitoring_mode', new Date().getTime())
        }
        if (this.state.activeStory == 'facing_monitoring_story') {
            localStorage.setItem('last_facing_monitoring_mode', new Date().getTime())
        }

        if (this.state.activeStory == 'facing_monitoring_story') {
            if (this.state.current_user.is_application == '2') {
                window.webkit.messageHandlers.startScanForInventarisation.postMessage(this.state.last_monitoring_product_name ?? '');
            } else {
                window.AndroidFunction.startScanForInventarisation(this.state.last_monitoring_product_name ?? '')
            }

        } else {
            if (this.state.current_user.is_application == '2') {
                window.webkit.messageHandlers.startScan.postMessage('test');
            } else {
                window.AndroidFunction.startScan('test')
            }
        }
    }

    receiveMessage = (event) => {
        if (event.data == 'cartSaved') {

            this.refreshState()
            return
        }
        // Обработка ошибки 401 - перезагрузка страницы только если пользователь был залогинен
        if (event.data.type !== undefined && event.data.type === 'unauthorized') {
            const wasLogined = this.state.is_logined
            BaseApi.clearAuthStorage()
            this.setState({is_logined: false, current_user: null, activePanel: 'login'})
            if (wasLogined) {
                window.location.reload()
            }
            return
        }
        if (event.data.type !== undefined && event.data.type === 'loginEvent') {

            if (event.data.error === undefined) {
                // this.setState({is_logined: true})
                removeForm1()
                // this.setState({activePanel: 'logined'})
                localStorage.setItem(constants.USER_NAME, this.state.username)
                localStorage.setItem(constants.PASSWORD, this.state.password)

                // Fresh login — drop stale rec_sclads (e.g. empty list from previous session)
                BaseApi.clearRecScladsCache()
                this.checkLogin()
            } else {

                this.setState({is_logined: false})
                localStorage.setItem(constants.USER_NAME, undefined)
                localStorage.setItem(constants.PASSWORD, undefined)

                this.openErrorNoty("Не известный логин и пароль")
            }
        }
        if (event.data.type !== undefined && event.data.type === 'setMainState') {
            this.setState({...event.data.value})
        }

        if (event.data.type !== undefined && event.data.type === 'saveCurrentPhone') {
            localStorage.setItem(constants.current_phone_key, event.data.value)
            this.setState({current_phone: event.data.value})
            return
        }


        if (event.data.type !== undefined && event.data.type === 'saveOrderComment') {
            localStorage.setItem(constants.current_order_comment_key, event.data.value)
            this.setState({current_comment: event.data.value})
            return
        }

        if (event.data.type !== undefined && event.data.type === 'last_monitoring_product_name' && event.data.productName) {
            this.setState({last_monitoring_product_name: event.data.productName})
            return
        }

        if (event.data.type !== undefined && event.data.text !== undefined) {
            if (event.data.type == 'error') {
                this.openErrorNoty(event.data.text, event.data.timeout)
            }

            if (event.data.type == 'success') {
                this.openLoadingNoty(event.data.text, event.data.timeout, event.data.hideSpinner)
            }


            if (event.data.type == 'helpMessage') {
                this.openHelpNoty(event.data.text, event.data.timeout)
            }

        } else if (event.data == 'goGetBack') {
            if (this.state.activeStory == 'cart_story') {
                window.postMessage('cartGoGetBack')

            } else if (this.state.activeStory == 'incoming_story') {
                window.postMessage('incomingGoGetBack')
            } else if (this.state.activeStory == 'klients_story' && this.state.activePanelKlients != 'panel_klients_list') {
                return
            } else {
                this.storyBack()
            }
        }
        if (event.data == 'clearGetVarsSearch' && this.get_vars !== undefined) {
            delete this.get_vars.search
        }


        if (event.data == 'getRecScladsLoaded' && BaseApi.rec_sclads) {
            if (BaseApi.rec_sclads.length == 1) {
                const rec_sclad = BaseApi.rec_sclads[0]
                this.setState({rec_sclad: rec_sclad})
            }

            if (BaseApi.rec_sclads.length > 1) {
                const rec_sclad = null
                this.setState({rec_sclad: rec_sclad})
            }
        }
        if (event.data == 'startScan') {
            this.startScan()
        }
        if (event.data == 'goMainBack') {
            this.storyBack()
        }

        if (event.data == 'checkFavourites') {
            this.checkFavourites()
        }
        if (event.data == 'goToMonitoringCreate') {
            this.setActiveStory('monitoring_create_story')
        }


        if (event.data == 'goToMonitoring') {
            this.setState({mainCatalogSavedState: null})
            this.setState({ostatki_club_mode: false})
            this.setState({monitoring_mode: true})
            this.setActiveStory('ostatki_story')
        }
        if (event.data == 'goToMain') {
            this.setState({ostatki_club_mode: false})
            this.setState({monitoring_mode: false})
            this.setActiveStory('default_story')
        }
        if (event.data == 'goCatalog') {
            this.setState({mainCatalogSavedState: null})
            this.setState({ostatki_club_mode: false})
            this.setState({monitoring_mode: false})
            this.setActiveStory('ostatki_story')
        }

        if (event.data == 'goToCart') {
            this.setState({ostatki_club_mode: false})
            this.setState({monitoring_mode: false})
            this.setActiveStory('cart_story')
        }
        if (event.data == 'goToFirmFitCatalog') {
            this.setState({mainCatalogSavedState: null})
            this.setState({monitoring_mode: false})
            this.setState({ostatki_club_mode: true})
            this.setActiveStory('ostatki_story')
        }

        if (event.data == 'goToFirmFitReport') {
            this.setState({monitoring_mode: false})
            this.setState({ostatki_club_mode: true})
            this.setActiveStory('report_ffc_story')
        }
        if (event.data == 'goToMonitoringDocs') {
            this.setState({ostatki_club_mode: false})
            this.setState({monitoring_mode: false})
            this.setActiveStory('monitoringdocs_story')
        }
        if (event.data == 'showCartNext') {
            this.setState({showCartNext: true})
        }
        if (event.data == 'hideCartNext') {
            this.setState({showCartNext: false})
        }
    }


    setProtectAddress = (e) => {
        this.setState({protect_address: e.value})
    }

    checkFavourites = () => {


        axios.get(this.state.base_url + '?app=partnersproducts&act=checkFavourites',
            {
                withCredentials: true

            }
        ).then((response) => {
            let current_user = this.state.current_user
            if (response.data.has_favourites == '1') {
                current_user.has_favourites = '1'
            } else {
                current_user.has_favourites = '0'
            }
            this.setState({current_user})
        })

    }


    /**
     * Проверяет, истёк ли кэш для указанного типа данных
     * @param {string} lastUpdateKey - Ключ для timestamp последнего обновления
     * @returns {boolean} true если кэш истёк или отсутствует
     */
    isCacheExpired = (lastUpdateKey) => {
        const lastUpdate = localStorage.getItem(lastUpdateKey);
        if (!lastUpdate) return true;
        
        const elapsed = Date.now() - parseInt(lastUpdate, 10);
        return elapsed > TYPES_CACHE_TTL_MS;
    }

    /**
     * Загружает типы оборудования с сервера и сохраняет в localStorage
     * @param {boolean} force - Принудительная загрузка, игнорируя кэш
     * @returns {Promise<Object|null>} Типы оборудования или null при ошибке/использовании кэша
     */
   loadEquipmentTypesFromServer = async (force = false) => {
        // Проверяем, нужно ли обновлять кэш
        if (!force && !this.isCacheExpired(equipment_types_last_update_key)) {
            console.log('⏳ Типы оборудования: кэш актуален, пропускаем запрос к серверу');
            return null; // Используем существующий кэш
        }

        try {
            const response = await equipmentTypesApi.getList();
            if (response && response.data && response.data.results) {
                const types = response.data.results;

                // Добавляем дополнительные значения (из старой логики)
                const extendedTypes = {
                    0: 'Не указан',
                    ...types
                };

                // Сортируем по алфавиту, оставляя "Не указан" первым
                const sortedEntries = Object.entries(extendedTypes).sort((a, b) => {
                    if (a[0] == 0) return -1;
                    if (b[0] == 0) return 1;
                    return a[1].localeCompare(b[1], 'ru');
                });

                const sortedTypes = {};
                sortedEntries.forEach(([key, value]) => {
                    sortedTypes[key] = value;
                });

                // Сохраняем в localStorage
                localStorage.setItem(equipment_types_cache_key, JSON.stringify(sortedTypes));
                localStorage.setItem(equipment_types_last_update_key, Date.now().toString());
                console.log('✅ Типы оборудования загружены с сервера и сохранены в кэш');

                return sortedTypes;
            }
            return null;
        } catch (error) {
            console.error('❌ Ошибка при загрузке типов оборудования с сервера:', error);
            return null;
        }
    }

    /**
     * Загружает типы торговых точек с сервера и сохраняет в localStorage
     * @param {boolean} force - Принудительная загрузка, игнорируя кэш
     * @returns {Promise<Object|null>} Типы торговых точек или null при ошибке/использовании кэша
     */
    loadSalePointTypesFromServer = async (force = false) => {
        // Проверяем, нужно ли обновлять кэш
        if (!force && !this.isCacheExpired(sale_point_types_last_update_key)) {
            console.log('⏳ Типы торговых точек: кэш актуален, пропускаем запрос к серверу');
            return null;
        }

        try {
            const response = await salePointTypesApi.getList();
            if (response && response.data && response.data.results) {
                const types = response.data.results;

                // Добавляем дополнительные значения (из старой логики)
                const extendedTypes = {
                    null: 'Торговый объект',
                    '': 'Не указан',
                    ...types
                };

                // Сохраняем в localStorage
                localStorage.setItem(sale_point_types_cache_key, JSON.stringify(extendedTypes));
                localStorage.setItem(sale_point_types_last_update_key, Date.now().toString());
                console.log('✅ Типы торговых точек загружены с сервера и сохранены в кэш');

                return extendedTypes;
            }
            return null;
        } catch (error) {
            console.error('❌ Ошибка при загрузке типов торговых точек с сервера:', error);
            return null;
        }
    }

    /**
     * Загружает ракурсы изображений с сервера и сохраняет в localStorage
     * @param {boolean} force - Принудительная загрузка, игнорируя кэш
     * @returns {Promise<Object|null>} Ракурсы изображений или null при ошибке/использовании кэша
     */
    loadImageAnglesFromServer = async (force = false) => {
        // Проверяем, нужно ли обновлять кэш
        if (!force && !this.isCacheExpired(image_angles_last_update_key)) {
            console.log('⏳ Ракурсы изображений: кэш актуален, пропускаем запрос к серверу');
            return null;
        }

        try {
            const response = await imageAnglesApi.getList();
            if (response && response.data && response.data.results) {
                const types = response.data.results;

                // Добавляем дополнительные значения (из старой логики)
                const extendedTypes = {
                    ...types
                };

                // Сохраняем в localStorage
                localStorage.setItem(image_angles_cache_key, JSON.stringify(extendedTypes));
                localStorage.setItem(image_angles_last_update_key, Date.now().toString());
                console.log('✅ Ракурсы изображений загружены с сервера и сохранены в кэш');

                return extendedTypes;
            }
            return null;
        } catch (error) {
            console.error('❌ Ошибка при загрузке ракурсов изображений с сервера:', error);
            return null;
        }
    }

    /**
     * Загружает торговые марки с сервера и сохраняет в localStorage
     * @param {boolean} force - Принудительная загрузка, игнорируя кэш
     * @returns {Promise<Object|null>} Торговые марки или null при ошибке/использовании кэша
     */
    loadTrademarksFromServer = async (force = false) => {
        // Проверяем, нужно ли обновлять кэш
        if (!force && !this.isCacheExpired(trademarks_last_update_key)) {
            console.log('⏳ Торговые марки: кэш актуален, пропускаем запрос к серверу');
            return null;
        }

        try {
            const response = await trademarksApi.getList();
            if (response && response.data && response.data.results) {
                const trademarks_ = response.data.results;

                let trademarks ={}

                trademarks_.map(el => trademarks[el.id] = el.title)
                // Добавляем дополнительные значения
                const extendedTrademarks = {
                    '': 'Не указана',
                    ...trademarks
                };

                // Сохраняем в localStorage
                localStorage.setItem(trademarks_cache_key, JSON.stringify(extendedTrademarks));
                localStorage.setItem(trademarks_last_update_key, Date.now().toString());
                console.log('✅ Торговые марки загружены с сервера и сохранены в кэш');

                return extendedTrademarks;
            }
            return null;
        } catch (error) {
            console.error('❌ Ошибка при загрузке торговых марок с сервера:', error);
            return null;
        }
    }

    /**
     * Загружает схему опросника мониторинга с сервера и сохраняет в localStorage
     * @param {boolean} force - Принудительная загрузка, игнорируя кэш
     * @returns {Promise<Object|null>}
     */
    loadMonitoringQuestionsFromServer = async (force = false) => {
        if (!force && !this.isCacheExpired(monitoring_questions_last_update_key)) {
            console.log('⏳ Опросник мониторинга: кэш актуален, пропускаем запрос к серверу');
            return null;
        }

        try {
            const response = await monitoringQuestionsApi.getList();
            if (response && response.data) {
                const schema = {
                    questions: constants.dedupeMonitoringQuestions(response.data.questions || []),
                    tree: response.data.tree || [],
                    qualifications: response.data.qualifications || {},
                };
                localStorage.setItem(monitoring_questions_cache_key, JSON.stringify(schema));
                localStorage.setItem(monitoring_questions_last_update_key, Date.now().toString());
                console.log('✅ Опросник мониторинга загружен с сервера и сохранён в кэш');
                return schema;
            }
            return null;
        } catch (error) {
            console.error('❌ Ошибка при загрузке опросника мониторинга с сервера:', error);
            return null;
        }
    }

    loadStaffPositionsFromServer = async (force = false) => {
        if (!force && !this.isCacheExpired(staff_positions_last_update_key)) {
            return null;
        }

        try {
            const response = await staffPositionsApi.getList();
            if (response && response.data && response.data.results) {
                const types = response.data.results;
                const extendedTypes = {
                    0: 'Не указана',
                    ...types
                };
                localStorage.setItem(staff_positions_cache_key, JSON.stringify(extendedTypes));
                localStorage.setItem(staff_positions_last_update_key, Date.now().toString());
                return extendedTypes;
            }
            return null;
        } catch (error) {
            console.error('Ошибка при загрузке должностей с сервера:', error);
            return null;
        }
    }

    /**
     * Инициализирует типы при запуске приложения
     * Запрашивает с сервера только если прошло более 30 минут с последнего обновления
     * При отсутствии сети или ошибке использует кэш из localStorage
     * @param {boolean} force - Принудительная загрузка всех типов, игнорируя кэш
     * @param {boolean} hasAddressProgram - Загружать типы только для пользователей с адресной программой
     * @returns {Promise<{equipmentTypes: Object, salePointTypes: Object, imageAngles: Object, trademarks: Object, monitoringQuestions: Object, staffPositions: Object}>}
     */
    initializeTypes = async (force = false, hasAddressProgram = false) => {
        console.log('🚀 Инициализация типов (TTL кэша: 30 мин)...');

        // imageAngles загружаем всегда, остальные типы только для АП
        const promises = [this.loadImageAnglesFromServer(force)];
        
        if (hasAddressProgram) {
            promises.push(
                this.loadEquipmentTypesFromServer(force),
                this.loadSalePointTypesFromServer(force),
                this.loadTrademarksFromServer(force),
                this.loadMonitoringQuestionsFromServer(force),
                this.loadStaffPositionsFromServer(force)
            );
        } else {
            console.log('⏭️ Пропуск загрузки типов оборудования, точек и торговых марок (пользователь без АП)');
        }

        const results = await Promise.all(promises);
        
        // Распределяем результаты в зависимости от того, загружались ли типы АП
        let equipmentTypes = null;
        let salePointTypes = null;
        let trademarks = null;
        let monitoringQuestions = null;
        let staffPositions = null;
        const imageAngles = results[0];

        if (hasAddressProgram) {
            equipmentTypes = results[1];
            salePointTypes = results[2];
            trademarks = results[3];
            monitoringQuestions = results[4];
            staffPositions = results[5];
        }

        // Используем результаты загрузки или fallback на кэш
        const equipmentTypesResult = equipmentTypes || (hasAddressProgram ? getEquipmentTypes() : {});
        const salePointTypesResult = salePointTypes || (hasAddressProgram ? getSalePointsTypes() : {});
        const imageAnglesResult = imageAngles || getImageAngles();
        const trademarksResult = trademarks || (hasAddressProgram ? getTrademarks() : {});
        const monitoringQuestionsResult = monitoringQuestions || (hasAddressProgram ? getMonitoringQuestions() : {questions: [], tree: [], qualifications: {}});
        const staffPositionsResult = staffPositions || (hasAddressProgram ? getStaffPositions() : {});

        // Подсчитываем сколько запросов реально ушло на сервер
        const serverRequests = [equipmentTypes, salePointTypes, imageAngles, trademarks, monitoringQuestions, staffPositions].filter(Boolean).length;
        const totalTypes = hasAddressProgram ? 6 : 1;
        console.log(`📊 Инициализация завершена: ${serverRequests}/${totalTypes} запросов к серверу, ${totalTypes - serverRequests}/${totalTypes} из кэша`);

        return {
            equipmentTypes: equipmentTypesResult,
            salePointTypes: salePointTypesResult,
            imageAngles: imageAnglesResult,
            trademarks: trademarksResult,
            monitoringQuestions: monitoringQuestionsResult,
            staffPositions: staffPositionsResult
        };
    }
}

export const current_theme = localStorage.getItem(constants.current_theme_key) ?? 'light'

if (current_theme === 'dark') {
    import('./theme/dark/onlyColors.css')
} else {
    import('./theme/light/onlyColors.css')
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <ConfigProvider/* isWebView={true} appearance="light" */ appearance={current_theme}
                                                             webviewType={WebviewType.INTERNAL}>
        <CookiesProvider>
            <AdaptivityProvider>

                <App/>
                <PhotoStorage baseUrl={constants.DEBUG ? constants.base_url_stage : constants.base_url_prod}/>

                <StandsSync autoSync requiresAddressProgram syncTTL={BRANDS_SYNC_TTL_MS}/>
                <StandCollectionsSync autoSync requiresAddressProgram syncTTL={BRANDS_SYNC_TTL_MS}/>
                <StandKitsSync autoSync requiresAddressProgram syncTTL={BRANDS_SYNC_TTL_MS}/>
                <SalePointMonitoringDocsSync autoUpload/>
            </AdaptivityProvider>
        </CookiesProvider>
    </ConfigProvider>
);
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('/react/service-worker.js', {
            scope: '/'  // Указываем кастомную область действия
        })
            .then((registration) => {
                console.log('Service Worker зарегистрирован с областью:', registration.scope);
            })
            .catch((error) => {
                console.error('Ошибка при регистрации Service Worker:', error);
            });
    });
}